import { useEffect, useState } from 'react';
import { getConversion } from '../services';
import { IConversionItem, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function useConversion(
	from: string,
	to: string,
	options?: { sellerId?: number; team?: string },
): HookState<IConversionItem[]> {
	const [state, setState] = useState<HookState<IConversionItem[]>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const sellerId = options?.sellerId;
	const team = options?.team;

	useEffect(() => {
		if (!from || !to) return;

		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getConversion(from, to, { sellerId, team })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [from, to, sellerId, team]);

	return state;
}
